export default __webpack_public_path__ + "static/media/avatar3.4d26ce02.png";